module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="l-grid-layout-33 b-search-employee-row">\n	<div class="b-search-employee">\n		<span class="js-widget"  onclick=\'return new Widgets.EmployeeAutocomplete({ bindingProperty: "' + bindingProperty + '", deletableField: true, client: "' + company.uid + '", formatter: ' + employeeFormatter + ' })\'></span>\n	</div>\n</div>\n';

}
return __p
}